<template>
    <div> 
        <div class="mainTitle d-flex align-items-center justify-content-center ">
            <h2 class="mb-3">{{ $t('bl_bonusList')}}</h2>
        </div> 
    	<div class="inMiddle-area table-responsive p-3 whiteBG CommentsTable "> 
			<table class="table customize">
				<thead>
					<tr>
                        <th>{{$t('bl_created')}}</th>
						<th>{{$t('dash_tradAccId')}}</th>
                        <th>{{$t('bl_amount')}}</th>
						<th>{{$t('dash_currency')}}</th>
                        <th>{{$t('bl_bonusType')}}</th>
                        <th>{{$t('bl_status')}}</th>
					</tr>
				</thead>
				<tbody v-if="(!pageLoader && bonusList != '' && bonusList.totalRecords > 0)">
                    <tr v-for="list in bonusList.records" >
                        <td>{{list.created | moment("DD MMMM YYYY")}}</td>
                        <td>{{list.account_id}} </td>
                        <td>{{list.amount}}</td>
                        <td>{{list.currency}}</td>
                        <td>{{$env_var.bonusType[list.bonustype]}}</td>
                        <td><span class="alert alert-success" v-if="parseInt(list.bonus_status) == 1">{{$t('bl_complete')}}</span><span class="alert alert-danger" v-else>{{$t('bl_pending')}}</span></td>
                    </tr>
                </tbody>
                <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="bonusList" v-else></loader-component>
			</table>
		</div>
		<pagination :getList="bonusList" :limit="pageLimit" v-if="bonusList.totalRecords > 15"></pagination>
    </div>
</template>
<script>
    export default {
        name: 'Bonus-List',
        data() {
            return {
                //===========prop in loader component=======
                col_span : 6,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1'
            }
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this, 'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetBonusList(inputJson)
            }
        },
        created(){
            if(this.bonusList.records != undefined){
                this.loaderFuncRun = '0'
            }

            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bonus/pages/bonus_list.vue